var _style, _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.3",
    style: {
      enableBackground: "new 0 0 689.9 563.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3DDB5;}\r\n\t.st1{fill:#36504B;}\r\n\t.st2{fill:#B0F7D5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.4,
    cy: 68.1,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.8,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.8,
    cy: 174.5,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 565,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 660.9,
    cy: 410.4,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 616.6,
    cy: 534.3,
    r: 28.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M577.6,285.4h-66v-30h45c8.3,0,15-6.7,15-15v-134c0-8.3-6.7-15-15-15h-180c-8.3,0-15,6.7-15,15v134 c0,8.3,6.7,15,15,15h45v30H326v-48.8c0-16.2-9.5-31.1-24.2-37.9L279.2,188c10-13.4,16-29.9,16-47.9v-26.9c0-44-35.8-79.9-79.9-79.9 s-79.9,35.8-79.9,79.9v26.9c0,17.9,5.9,34.4,15.9,47.7l-22.5,10.9c-14.7,6.8-24.1,21.7-24.1,37.9v48.8h-9.1c-8.3,0-15,6.7-15,15v60 c0,8.3,6.7,15,15,15h6v145c0,8.3,6.7,15,15,15h440c8.3,0,15-6.7,15-15v-145h6c8.3,0,15-6.7,15-15v-60 C592.6,292.1,585.9,285.4,577.6,285.4z M481.6,285.4h-30v-49c0-8.3,6.7-15,15-15s15,6.7,15,15V285.4z M391.6,121.4h150v104h-31.4 c-4.9-19.5-22.6-34-43.6-34s-38.7,14.5-43.6,34h-31.4V121.4z M562.6,345.4h-452v-30h452V345.4z M165.5,126.7 c4.1,0.8,8.3,1.2,12.5,1.2c13.4,0,26.5-4.2,37.3-11.7c10.9,7.5,23.9,11.7,37.3,11.7c4.2,0,8.4-0.4,12.5-1.2v13.4 c0,27.5-22.4,49.9-49.9,49.9c-27.5,0-49.9-22.4-49.9-49.9L165.5,126.7z M206.1,221.6h20.2l4.3,43l-14.4,15.2l-14.4-15.2 L206.1,221.6z M289.2,226c4.2,1.9,6.8,6.1,6.8,10.7v48.8h-43.8l4.9-5.2c3-3.2,4.5-7.5,4-11.8l-5.8-58.6c0.2,0.1,0.3,0.2,0.5,0.3 l33.2,15.8C289.1,225.9,289.1,225.9,289.2,226L289.2,226z M215.3,63.4c21.6,0,40.1,13.9,47,33.2c-3.1,0.9-6.4,1.3-9.7,1.3 c-10,0-19.5-4.2-26.2-11.6c-2.8-3.1-6.9-4.9-11.1-4.9c-4.2,0-8.3,1.8-11.1,4.9c-6.7,7.4-16.3,11.6-26.2,11.6 c-3.3,0-6.5-0.5-9.7-1.3C175.2,77.3,193.7,63.4,215.3,63.4z M134.7,236.6c0-4.6,2.7-8.8,6.8-10.7c0.1,0,0.2-0.1,0.3-0.1l33.9-16.4 c0.5,0.3,0.9,0.6,1.4,0.8l-5.8,58.2c-0.4,4.3,1,8.6,4,11.8l4.9,5.2h-45.5V236.6z M541.5,505.4h-410v-130h410V505.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M541.5,375.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.5,505.4v-130h410c-61.6,4.3-142.5,16.1-232.8,47C236.5,447.2,177.2,477.7,131.5,505.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono1);
export default __webpack_public_path__ + "static/media/icono1.e7f8aaf3f3590886b03bd15ec3a8aea6.svg";
export { ForwardRef as ReactComponent };